import React from "react";
import { useState } from "react";
import { Link } from 'react-router-dom';

import SearchBar from "./common/SearchBar";
import { GetTaskStatus } from "./Task.js"


function Task({id, form, user, status, deadline_date, completed_date}){

  let statusDisplay = GetTaskStatus(status);

  return(
    <tr className="">
      <td><Link className="" to={`/task/` + id}> {user.username}</Link></td>
      <td>{form}</td>
      <td>{status=== "SENT" ? 
          <span className="text-primary fw-semibold">{statusDisplay}</span> 
        : 
          status=== "OUTDATED" ? 
            <span className="text-danger fw-semibold">{statusDisplay}</span> 
          : 
            <span  className="">{statusDisplay}</span>
          }
      </td>
      <td>{deadline_date}</td>
      <td>{completed_date}</td>
    </tr>
  )

}


export default function TaskList({tasks}) {
  const [searchText, setSearchText] = useState('');

  let rows = [];
  for(let i in tasks) {
    console.log(tasks[i])
    if (tasks[i].lab.username.toLowerCase().indexOf(searchText.toLowerCase()) === -1) {
      //pass
    } else {

      rows.push(
        <Task
          key={tasks[i].id}
          id={tasks[i].id}  
          form={tasks[i].form}
          user={tasks[i].lab}
          status={tasks[i].status}
          deadline_date={tasks[i].deadline_date}
          completed_date={tasks[i].completed_date}
        />
      );
    }
  }

  return(
    <>
      <div className="row">
        <h3 className="m-3">Задания</h3>
      </div>
      <Link className="lk-button m-3" to={`/task_create`}>Создать задание</Link>
      <div className="m-3">
        <SearchBar
          key="SearchBar" 
          searchText={searchText} 
          onSearchtextChange={setSearchText} 
        />
      </div>
      <div className="row m-3">
        <table className="table">
          <thead>
            <tr> 
              <th>лаборатория</th>
              <th>форма</th>        
              <th>статус</th>
              <th>дата предоставления результатов</th>  
              <th>фактическая дата отправки</th>      
            </tr>
          </thead>
          <tbody>
            {rows} 
          </tbody>
        </table>
      </div>
    </>
  );
}
